/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create Account Request Body
 * @export
 * @interface LoginAccountRequest
 */
export interface LoginAccountRequest {
    /**
     * Username
     * @type {string}
     * @memberof LoginAccountRequest
     */
    username: string;
    /**
     * Password
     * @type {string}
     * @memberof LoginAccountRequest
     */
    password: string;
    /**
     * reCAPTCHA Token
     * @type {string}
     * @memberof LoginAccountRequest
     */
    recaptchaToken: string;
    /**
     * Retrieve Device Keys
     * @type {boolean}
     * @memberof LoginAccountRequest
     */
    retrieveDeviceKeys?: boolean;
}

/**
 * Check if a given object implements the LoginAccountRequest interface.
 */
export function instanceOfLoginAccountRequest(value: object): value is LoginAccountRequest {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    return true;
}

export function LoginAccountRequestFromJSON(json: any): LoginAccountRequest {
    return LoginAccountRequestFromJSONTyped(json, false);
}

export function LoginAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
        'recaptchaToken': json['recaptcha_token'],
        'retrieveDeviceKeys': json['retrieve_device_keys'] == null ? undefined : json['retrieve_device_keys'],
    };
}

export function LoginAccountRequestToJSON(value?: LoginAccountRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'username': value['username'],
        'password': value['password'],
        'recaptcha_token': value['recaptchaToken'],
        'retrieve_device_keys': value['retrieveDeviceKeys'],
    };
}

